module.exports = __webpack_public_path__ + "static/img/2010.795e8f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2010.png
// module id = +3F7
// module chunks = 0